<script>
import layout from '@src/mixins/layout.vue'
import { navComputed, navMethods } from '@state/helpers'
import { authService } from '@/src/services/safehaven/AuthService'
import store from '@state/store'
export default {
  mixins: [layout],
  data() {
    return {
      org: null,
      displayFilter: false,
      showSignin: false,
      docShare: false,
      qrCode: false,
    }
  },
  computed: {
    ...navComputed,
    logoComputed() {
      return this.$style.logoContainer
    },
  },
  created() {
    if (this.$route.name === 'recipient-qr-code-verification')
      this.qrCode = true
    if (this.$route.name === 'sharedqrcoderecords') this.qrCode = true

    if (this.$route.name === 'shared-documents') this.docShare = true
    else this.docShare = false
  },
  mounted() {
    this.getOrgDetails()
  },
  methods: {
    ...navMethods,
    toggleDrawer(drawer) {
      this.displayFilter = false
      this.setDrawer({
        value: !this.getDrawer(drawer),
        drawer: drawer,
      })
    },
    navigateToLogin() {
      if (this.docShare) {
        store.dispatch('calender/setRecordDetails', { path: 'health-vault' })
        store.dispatch('calender/setSharedRecordTabs', 'received-documents')
      } else
        store.dispatch('calender/setRecordDetails', {
          path: 'safehaven-health-record',
        })
    },
    getOrgDetails() {
      const orgName = this.$route.params.clientId
        ? this.$route.params.clientId.toLowerCase()
        : 'healthbook'
      authService.getLogo(orgName).then(
        (res) => {
          this.org = res.data
          localStorage.setItem('organisationDetails', JSON.stringify(res.data))
          let sharedOrg = null
          if (localStorage.getItem('recipientData')) {
            sharedOrg = JSON.parse(localStorage.getItem('recipientData'))
          } else {
            sharedOrg = JSON.parse(localStorage.getItem('sharedrecord'))
          }
          if (
            sharedOrg.recipient_org_id &&
            sharedOrg.recipient_org_id === sharedOrg.sender_org_id
          ) {
            this.showSignin = true
          } else {
            this.showSignin = false
          }
        },
        (err) => {
          if (
            err.response?.data &&
            err.response.data.org === 'Organization not found'
          ) {
            this.$router.push({
              name: '404',
              params: { clientId: this.$route.params.clientId },
            })
          }
        }
      )
    },
  },
}
</script>

<template>
  <v-app-bar
    v-if="org"
    :height="$vuetify.breakpoint.mdAndUp ? 76 : 55"
    color="white"
    clipped-left
    expand-on-hovers
    clipped
    elevate-on-scroll
    clipped-right
    elevation="1"
    app
  >
    <div v-if="qrCode" class="text-center" :class="$style.mobiledsmenu">
      <div v-if="qrCode" class="mx-auto" :class="$style.logoContainer">
        <v-img
          v-if="org"
          :height="$vuetify.breakpoint.mdAndUp ? 54 : 45"
          contain
          :class="[
            $style.logoImg,
            this.$route.params.clientId.toLowerCase() === 'healthbook'
              ? 'healthbook'
              : 'safehaven',
          ]"
          :src="org.logo_url"
        ></v-img>
      </div>
    </div>
    <div
      v-else
      class="d-flex flex-grow-1 align-center"
      :class="$style.mobilemenu"
    >
      <div :class="logoComputed">
        <v-img
          v-if="org"
          :height="$vuetify.breakpoint.mdAndUp ? 54 : 45"
          contain
          :class="[
            $style.logoImg,
            this.$route.params.clientId.toLowerCase() === 'healthbook'
              ? 'healthbook'
              : 'safehaven',
          ]"
          :src="org.logo_url"
        ></v-img>
      </div>
    </div>
    <v-row no-gutters class="justify-end px-5 mobilespaceclss">
      <v-spacer></v-spacer>
      <router-link
        v-if="showSignin"
        :class="$style.signinUrl"
        :to="{ name: 'safehaven-login' }"
        @click.native="navigateToLogin"
        >Sign in to my account</router-link
      >
    </v-row>
  </v-app-bar>
</template>

<style lang="scss" module scoped>
@import '@design';
.mobiledsmenu {
  width: 100%;
}
.logoContainer {
  width: 223px;
  max-width: 223px;
  height: 100%;
}

.healthbookLogoContainer {
  width: 340px !important;
  height: 100%;
}

.signinUrl {
  font-family: 'Open Sans', 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
}

.logoImg {
  background-position: left center;
}

.listItem {
  height: 35px;
  min-height: 0 !important;
  padding: 0 !important;
}
.actionBtn {
  justify-content: flex-start !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  letter-spacing: 0.25px;
}

@media screen and (max-width: 960px) {
  .logoContainer {
    width: 185px;
    max-width: 185px;
  }
}
@media screen and (max-width: 599px) {
  .mobilemenu {
    justify-content: space-between !important;
  }
  .mobilehide {
    display: none !important;
  }
}
@media screen and (max-width: 370px) {
  .logoContainer {
    width: 200px;
    max-width: 200px;
  }
}
@media screen and (max-width: 310px) {
  .logoContainer {
    width: 130px;
    max-width: 130px;
  }
}
</style>

<style scoped>
@media screen and (max-width: 400px) {
  /deep/ .px-5.mobilespaceclss {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
  .spacer {
    display: none !important;
  }
}
@media screen and (max-width: 370px) {
  /deep/ .v-toolbar__content {
    padding: 4px 8px !important;
  }
  /deep/.safehaven .v-image__image--cover {
    background-size: contain !important;
  }
}
@media screen and (max-width: 365px) {
  /deep/ .px-5.mobilespaceclss {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
@media screen and (max-width: 330px) {
  /deep/ .v-toolbar__content,
  .v-toolbar__extension {
    padding: 4px 4px;
  }
}
</style>
